import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ActionService } from 'src/app/services/actions/action.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { GetDocumentTypeRequest, GetDocumentTypeResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { DocumentType, DocumentTypeFunctionalAreasSelected, DocumentTypeMetadata } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../document-types-base.component';
import { DocumentTypeDocClassComponent } from './doc-class/doc-class.component';
import { DocumentTypeCommonComponent } from './document-type-common.component';
import { ElynkComponent } from './elynk/elynk.component';
import { TemplateMgrComponent } from './template-mgr/template-mgr.component';


@Component({
    selector: 'app-document-type-item',
    templateUrl: './document-type-item.component.html',
    styleUrls: ['./document-type-item.component.scss']
})
export class DocumentTypeItemComponent extends DocumentTypeBaseComponent {

    constructor(
        public actionService: ActionService,
        public configurationService: ConfigurationService

    ) {
        super(configurationService, actionService);
    }

    @ViewChild(DocumentTypeCommonComponent) docTypeForm: DocumentTypeCommonComponent;

    documentType: DocumentType = {
        id: 0,
        label: "",
        description: "",
        version: "",
        showInUI: false,
        type: "",
        metadata: { category: "" } as DocumentTypeMetadata,
        active: false,

    } as DocumentType;

    @Input() documentTypeId: number = 0;

    @Output() documentTypeRemoval = new EventEmitter();
    @Output() documentTypeAddition = new EventEmitter<DocumentType>();

    @ViewChild('elynk', { static: false }) elynk: ElynkComponent;
    @ViewChild('templateMgr', { static: false }) templateMgr: TemplateMgrComponent;
    @ViewChild('classification', { static: false }) classification: DocumentTypeDocClassComponent;

    get isNewDocumentType() {
        return this.documentTypeId === 0;
    }

    commonRemoveEvent() {
        this.documentTypeRemoval.emit();
    }

    commonAddEvent(event) {
        this.documentTypeAddition.emit(event);
    }

    async updateFunctionalAreas(event: DocumentTypeFunctionalAreasSelected) {
        if (!event.elynk) {
            this.elynk.clearElynk();
        }

        if (!event.documentClassification) {
            this.classification.clearClassification();
        }

        if (!event.templateManager) {
            this.templateMgr.clearTemplateManager();
        }
    }

    private async getDocumentType(documentTypeId: number): Promise<DocumentType> {
        const request = new GetDocumentTypeRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "document-type-get", request) as GetDocumentTypeResponse;
        return response.documentType;
    }
}
